export default "__VITE_ASSET__DK0_4CjZ__"